function hybridapi(methodName, ...methodArguments) {
  // Öncelik sırası:
  // 1. Android native API (window.hybridapi)
  // 2. iOS native API (window.webkit.messageHandlers)
  // 3. Iframe içindeyse parent window'a postMessage (web veya mobil app iframe)

  let usedNativeAPI = false;

  // 1. Android native API kontrolü
  if (window["hybridapi"] && window["hybridapi"][methodName]) {
    try {
      window["hybridapi"][methodName](
        ...methodArguments.map((arg) => {
          if (typeof arg == "object") {
            return JSON.stringify(arg);
          } else if (typeof arg == "number") {
            return "" + arg;
          }
          return arg;
        })
      );
      usedNativeAPI = true;
    } catch (error) {
      // Error silently handled
    }
  }
  // 2. iOS native API kontrolü
  else if (
    window["webkit"] &&
    window["webkit"]["messageHandlers"] &&
    window["webkit"]["messageHandlers"][methodName]
  ) {
    try {
      window["webkit"]["messageHandlers"][methodName]["postMessage"](
        methodArguments
      );
      usedNativeAPI = true;
    } catch (error) {
      // Error silently handled
    }
  }

  // 3. Native API kullanılmadıysa ve iframe içindeysek, parent window'a postMessage gönder
  // Bu hem web iframe hem de mobil app iframe senaryoları için çalışır
  if (
    !usedNativeAPI &&
    window.parent &&
    window.parent !== window &&
    (methodName === "hideLoading" ||
      methodName === "close" ||
      methodName === "showLoading" ||
      methodName === "showToast" ||
      methodName === "updatePageTitle" ||
      methodName === "openSessionedBrowser")
  ) {
    try {
      const allowedOriginsFromEnv = process.env.VUE_APP_ALLOWED_ORIGIN
        ? process.env.VUE_APP_ALLOWED_ORIGIN.split(",").map((origin) =>
            origin.trim()
          )
        : [];

      // iOS uygulamaları için origin'ler
      const iosAppOrigins = ["null", "file://"];

      const allowedOrigins = [
        window.location.origin,
        ...allowedOriginsFromEnv,
        ...iosAppOrigins,
      ].filter(Boolean);

      // iOS uygulama kontrolü
      const isIOSApp =
        (window["webkit"] && window["webkit"]["messageHandlers"]) ||
        window.location.protocol === "file:" ||
        window.location.origin === "null" ||
        navigator.userAgent.match(/iPhone|iPad|iPod/i);

      let targetOrigin = "*";
      try {
        // document.referrer varsa onu kullan
        if (document.referrer) {
          const referrerOrigin = new URL(document.referrer).origin;
          if (allowedOrigins.includes(referrerOrigin)) {
            targetOrigin = referrerOrigin;
          }
        }
        // window.location.ancestorOrigins varsa kontrol et
        if (
          window.location.ancestorOrigins &&
          window.location.ancestorOrigins.length > 0
        ) {
          const ancestorOrigin = window.location.ancestorOrigins[0];
          if (allowedOrigins.includes(ancestorOrigin)) {
            targetOrigin = ancestorOrigin;
          }
        }
        // Parent window'un origin'ini kontrol et
        if (window.parent && window.parent !== window) {
          try {
            const parentOrigin = window.parent.location.origin;
            if (allowedOrigins.includes(parentOrigin)) {
              targetOrigin = parentOrigin;
            }
          } catch (e) {
            // Cross-origin hatası - bu normal, mobil uygulamalarda olabilir
          }
        }
      } catch (e) {
        // Origin kontrolü başarısız olursa
        if (isIOSApp) {
          // iOS uygulamalarında "*" kullan (güvenli çünkü iOS app içindeyiz)
          targetOrigin = "*";
        } else {
          // Web'de güvenlik için sadece aynı origin için gönder
          targetOrigin = window.location.origin;
        }
      }

      window.parent.postMessage(
        {
          type: "hybridapi",
          method: methodName,
          arguments: methodArguments,
        },
        targetOrigin
      );
    } catch (error) {
      // Error silently handled
    }
  }

  // NOTE(baris): This log is used for testing. Hybrid methods should not be called in production if running as website.
  // console.error("$hybridapi:NONE " + methodName + " " + methodArguments);
}

export const check_hybridapi_method_exist = function (methodName) {
  // Android native API kontrolü
  if (window["hybridapi"] && window["hybridapi"][methodName]) {
    return true;
  }

  // iOS native API kontrolü
  if (
    window["webkit"] &&
    window["webkit"]["messageHandlers"] &&
    window["webkit"]["messageHandlers"][methodName]
  ) {
    return true;
  }

  return false;
};

export default hybridapi;
